export interface Disposable {
  dispose(): void;
}

/**
 * Lifecycle primitive mirrored from the table virtual-scroll. We keep a
 * local copy here so the gantt virtualizer is not coupled to the table
 * preset (which can evolve independently). Subclasses push cleanup
 * functions into `disposables` and call `dispose()` once.
 */
export class NodeLifeCycle implements Disposable {
  readonly disposables: (() => void)[] = [];
  isDisposed = false;

  init(): void {
    // Subclass override — base is a no-op on purpose.
  }

  dispose(): void {
    if (this.isDisposed) return;
    this.isDisposed = true;
    for (const fn of this.disposables) fn();
    this.disposables.length = 0;
  }
}
